/* Denne filen inneholder konfigurasjon for kartvisningen i applikasjonen.
   Den definerer oppsett for kartlag, basemaps, søkefunksjonalitet og andre kartrelaterte innstillinger. */

export default {
  mapViewStartupSettings: {
    zoom: 3,
    center: {
      spatialReference: { wkid: 25833 },
      x: 502798,
      y: 7169825,
    },
  },
  mainLayerArcGISOptions: {
    url: process.env.VUE_APP_BASE_URL,
    id: "mainLayer",
    title: "Tidsserier",
    sublayers: [
      {
        id: 0,
        labelingInfo: [
          {
            minScale: 320000,
            labelExpression: '[stasjonNr] CONCAT " " CONCAT [stasjonNavn]',
            labelPlacement: "center-center",
            symbol: {
              type: "text",
              backgroundColor: "#FFFFFF",
              haloColor: "#fcfcfc",
              haloSize: "2px",
              yoffset: 20,
              color: [0, 0, 0, 1],
              font: {
                size: 10,
                weight: "bolder",
                family: "Arial",
              },
            },
          },
        ],
      },
    ],
  },
  defaultMapExtent: {
    spatialReference: {
      latestWkid: 3857,
      wkid: 102100,
    },
    xmax: 5859947.691036401,
    xmin: -1429087.3262360683,
    ymax: 12001608.415561255,
    ymin: 7099854.665690776,
  },
  currentMapExtent: {
    spatialReference: {
      latestWkid: 3857,
      wkid: 102100,
    },
    xmax: 5859947.691036401,
    xmin: -1429087.3262360683,
    ymax: 12001608.415561255,
    ymin: 7099854.665690776,
  },
  timeSeriesOtherActorsLayer: {
    id: "andre-stasjoner-extra",
    title: "Andre stasjoner",
    identifyLayers: [0],
    visible: false,
    sublayers: [
      {
        id: 0,
        title: "Andre stasjoner",
        definitionExpression:
          "DATA_EIER_KATEGORI <> 'NVE' AND PARAMETERNAVN IN ('Nedbør', 'Temperatur', 'Snødybde')",
        popupEnabled: false,
      },
    ],
    url:
      "https://gis3.nve.no/map/rest/services/Mapservices/xgeoAllStations/MapServer",
  },
  kartlag: [
    {
      id: "administrativt",
      title: "Fylke/kommune",
      visible: false,
      identifyLayers: [0],
      sublayers: [
        {
          id: 3,
          visible: true,
          title: "Kommunegrense",
          popupEnabled: false,
        },
        {
          id: 2,
          visible: true,
          title: "Fylkesgrense",
          popupEnabled: false,
        },
        {
          id: 5,
          visible: true,
          title: "Kommunegrense",
          popupEnabled: false,
        },
        {
          id: 4,
          visible: true,
          title: "Fylkesgrense",
          popupEnabled: false,
        },
        {
          id: 8,
          visible: true,
          title: "Kommunegrense",
          popupEnabled: false,
        },
        {
          id: 7,
          visible: true,
          title: "Fylkesgrense",
          popupEnabled: false,
        },
      ],
      url:
        "https://kart.nve.no/enterprise/rest/services/Mapservices/Administrasjon2/MapServer",
    },
    {
      title: "Elvenett",
      id: "elvenett",
      visible: false,
      identifyLayers: [0, 1, 2],
      sublayers: [
        {
          id: 0,
          visible: true,
          title: "Oversikt",
          popupEnabled: false,
        },
        {
          id: 1,
          visible: true,
          title: "Hovedelv",
          popupEnabled: false,
        },
        {
          id: 2,
          visible: true,
          title: "Elvenett",
          popupEnabled: false,
        },
      ],
      url:
        "https://kart.nve.no/enterprise/rest/services/Elvenett1/MapServer",
    },
    {
      id: "nedborfelt",
      title: "Nedbørfelt",
      visible: false,
      identifyLayers: [0],
      sublayers: [
        {
          id: 0,
          visible: true,
          title: "Vassdragsområder",
          popupEnabled: false,
        },
        {
          id: 1,
          visible: false,
          title: "Nedbørfelt til hav",
          popupEnabled: false,
        },
        {
          id: 2,
          visible: false,
          title: "Sidenedbørfelt",
          popupEnabled: false,
        },
        {
          id: 3,
          visible: false,
          title: "REGINE enhet",
          popupEnabled: false,
        },
        {
          id: 4,
          visible: false,
          title: "Hele hierarkiet",
          popupEnabled: false,
        },
      ],
      url:
        "https://kart.nve.no/enterprise/rest/services/Nedborfelt2/MapServer",
    },
  ],
  searchUrl:
    "https://apps.geodataonline.no/autocomplete/rest/services/adresse/GeocodeServer/?token=",
  basemaps: [
    {
      id: "vektorgraatone",
      urlTemplate:
        "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheGraatone/VectorTileServer",
      subDomains: [],
      title: "Gråtone",
      thumbnailUrl: "/img/graatone.jpg",
      active: false,
      isVector: true,
    },
    {
      id: "vektorterreng",
      urlTemplate:
        "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheBasisTerreng/VectorTileServer",
      subDomains: [],
      title: "Farge",
      thumbnailUrl: "/img/landskap.jpg",
      active: false,
      isVector: true,
    },
    {
      id: "ortofoto",
      urlTemplate:
        "https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM33_EUREF89/GeocacheBilder/MapServer",
      subDomains: [],
      title: "Bilder",
      thumbnailUrl: "/img/bilder.jpg",
      active: false,
      isVector: false,
    },
    {
      id: "graatonecache",
      urlTemplate:
        "https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM33_EUREF89/GeocacheGraatone/MapServer",
      title: "Europa",
      thumbnailUrl: "/img/graatone.jpg",
      active: false,
      isVector: false,
    },
  ],
};
